import { PureComponent } from 'react';
import { View, ScrollView, TouchableOpacity, Image } from 'react-native';
import { Label, DocumentTitle, LabelledView, PickerInput, Link, Text, Loading } from '@symbolic/rn-lib';
import { api } from '@symbolic/lib';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';
import { accentColorForOrg } from '~/helpers/org-helper';
import _ from '@symbolic/lodash';

import K from '~/k';
import AdminMenu from '~/components/admin-menu';
import SecondaryHeader from '~/components/secondary-header';

import createIconWhite from '~/assets/create-icon-white.png';

class ProductOptionClassifierGroupRow extends PureComponent {
  render() {
    var {productOptionClassifierGroup} = this.props;

    var textCellStyle = {paddingHorizontal: K.spacing};

    return (
      <View
        dataSet={{'hover-background-double-gray': 1}}
        style={{flexDirection: 'row', alignItems: 'center', height: 30, borderRadius: K.borderRadius, backgroundColor: K.colors.gray, marginBottom: K.margin, marginHorizontal: K.spacing}}
      >
        <Link to={`/admin/product-option-classifier-groups/${productOptionClassifierGroup.id}`} style={{paddingLeft: K.spacing, flexDirection: 'row', flex: 1, height: '100%', alignItems: 'center'}}>
          <Text style={{width: 75, opacity: 0.5, ...textCellStyle}}>{productOptionClassifierGroup.id}</Text>
          <Text style={{flex: 1, ...textCellStyle}}>{productOptionClassifierGroup.title}</Text>
        </Link>
      </View>
    );
  }
}

class AdminProductOptionClassifierGroupsPage extends PureComponent {
  state = {
    filterMode: 'active',
    isLoading: true
  };

  async componentDidMount() {
    var productOptionClassifierGroups = await api.get('productOptionClassifierGroups', {where: {orgId: this.props.session.activeOrg.id}});

    await this.props.trackProductOptionClassifierGroups({productOptionClassifierGroups});

    setTimeout(() => this.setState({isLoading: false}));
  }

  handleFilterModeChange = ({value}) => this.setState({filterMode: value});

  createProductOptionClassifierGroup = async () => {
    var classifierGroup = await api.create('productOptionClassifierGroup', {
      orgId: this.props.session.activeOrg.id,
      title: 'Untitled Classifier Group'
    });

    this.props.trackProductOptionClassifierGroups({productOptionClassifierGroups: [classifierGroup]});
  };

  render() {
    var {productOptionClassifierGroups} = this.props;
    var {filterMode} = this.state;

    var filteredProductOptionClassifierGroups = _.filter(productOptionClassifierGroups, productOptionClassifierGroup => {
      if (filterMode === 'active') return !productOptionClassifierGroup.deleted;
      if (filterMode === 'deleted') return !!productOptionClassifierGroup.deleted;
      if (filterMode === 'all') return true;
    });

    return (
      <DocumentTitle title={'Admin: Product Option Classifier Groups'}>
        <View style={{flex: 1, flexDirection: 'row'}}>
          <AdminMenu activeOrg={this.props.session.activeOrg} />
          <View style={{flex: 1}}>
            <SecondaryHeader
              title={'Product Option Classifier Groups'}
              titleIsEditable
              rightComponent={(
                <View style={{right: 20}}>
                  <LabelledView label='Status' styles={{paddingTop: K.spacing}}>
                    <PickerInput
                      style={{height: K.inputHeight}}
                      buttonStyle={{backgroundColor: K.colors.doubleGray}}
                      showDownArrow={true}
                      options={[
                        {value: 'active', title: 'Active'},
                        {value: 'deleted', title: 'Deleted'},
                        {value: 'all', title: 'All'},
                      ]}
                      value={this.state.filterMode}
                      onChange={this.handleFilterModeChange}
                    />
                  </LabelledView>
                </View>
              )}
            />
            {this.state.isLoading ? (
              <Loading />
            ) : (
              <>
                <ScrollView style={{flex: 1}} contentContainerStyle={{addingTop: K.spacing, paddingBottom: K.spacing * 4}}>
                  <View style={{paddingLeft: K.spacing * 2, flexDirection: 'row', marginRight: K.spacing}}>
                    {_.map([
                      {title: 'ID', style: {width: 75}},
                      {title: 'Title', style: {flex: 1}}
                    ], ({title, style}, h) => (
                      <View key={h}
                        style={{...style, padding: K.spacing}}
                      >
                        <Label>{title}</Label>
                      </View>
                    ))}
                  </View>
                  <View>
                    {_.map(_.sortBy(filteredProductOptionClassifierGroups, ['id']), (productOptionClassifierGroup) => (
                      <ProductOptionClassifierGroupRow
                        key={productOptionClassifierGroup.id}
                        {...{productOptionClassifierGroup}}
                      />
                    ))}
                  </View>
                </ScrollView>
                <TouchableOpacity
                  onPress={() => this.createProductOptionClassifierGroup()}
                  style={{position: 'fixed', bottom: K.spacing * 2, left: K.spacing * 2, backgroundColor: accentColorForOrg({org: this.props.session.activeOrg}), width: 70, height: 70, borderRadius: 70, alignItems: 'center', 'justifyContent': 'center'}}
                >
                  <Image source={createIconWhite} style={{width: K.calc(35), height: K.calc(35)}}/>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      </DocumentTitle>
    );
  }
}

export default connect({
  mapState: (state) => ({
    productOptionClassifierGroups: _.get(state, 'resources.productOptionClassifierGroups.byId')
  }),
  mapDispatch: {
    ..._.pick(resourceActions.productOptionClassifierGroups, ['updateProductOptionClassifierGroups', 'trackProductOptionClassifierGroups']),
  }
})(AdminProductOptionClassifierGroupsPage);
